export const menu = [
    {
        id:1,
        name:'会议首页',
        engLishName:'Home',
        path:'/conference/index'
    },
    {
        id:101,
        name:'大会介绍',
        engLishName:'Conference Introduction',
        children:[]
    },
    {
        id:102,
        name:'大会嘉宾',
        engLishName:'Conference Guests',
        children:[]
    },
    {
        id:103,
        name:'大会笔记',
        engLishName:'Conference Notes',
        children:[]
    },
    {
        id:104,
        name:'参会参展',
        engLishName:'Conference Exhibition',
        children:[]
    },
    {
        id:105,
        name:'同期活动',
        engLishName:'Other Events',
        children:[]
    },
    {
        id:106,
        name:'赞助机会',
        engLishName:'Sponsorship Opportunities',
        children:[]
    },
    {
        id:107,
        name:'下载中心',
        engLishName:'Download Center',
        children:[]
    },
    {
        id:108,
        name:'优秀品牌',
        engLishName:'Excellent Brands',
        children:[]
    },
    {
        id:109,
        name:'联系联盟',
        engLishName:'Contact Alliance',
    }
];